<rt-heading> {{ 'app.evaluation_insights.tooltip.evaluation_score' | translate }} </rt-heading>
<div layout layout-align-items-center>
  {{ tooltipText() }}
  <rt-admins-avatars
    margin-left-small-x
    [admins]="users()"
    [stacked]="true"
    [avatarSize]="'top-nav-company-selector'"
  />
</div>
@if (isInsightsVisible()) {
  <rt-evaluation-quick-insight [insightQuickContent]="insightQuickContent()" />
}
<div class="arrow"></div>
